module.exports = __webpack_public_path__ + "static/media/horse ride.954c95c0.webp";